export interface PhonePresentation {
  displayFullNumber: string;
  fullNumber: string;
  countryCallingCode: string;
  numberWithoutCountryCode: string;
}

const ONE_DIGIT_CALLING_CODES = new Set(['1', '7']);

const TWO_DIGIT_CALLING_CODES = new Set([
  '20', '27',
  '30', '31', '32', '33', '34', '36', '39', '40', '41', '43', '44', '45', '46', '47', '48', '49',
  '51', '52', '53', '54', '55', '56', '57', '58',
  '60', '61', '62', '63', '64', '65', '66',
  '81', '82', '84', '86',
  '90', '91', '92', '93', '94', '95', '98',
]);

function callingCodeLength(digits: string): number {
  if (ONE_DIGIT_CALLING_CODES.has(digits.slice(0, 1))) return 1;
  if (TWO_DIGIT_CALLING_CODES.has(digits.slice(0, 2))) return 2;

  // Остальные назначенные международные телефонные коды E.164 состоят из трёх цифр.
  return digits.length > 3 ? 3 : 0;
}

export function presentPhoneNumber(value: string): PhonePresentation {
  const source = String(value || '').trim();
  let digits = source.replace(/\D/g, '');

  if (source.startsWith('00')) {
    digits = digits.slice(2);
  }

  if (!digits) {
    return {
      displayFullNumber: '—',
      fullNumber: '',
      countryCallingCode: '',
      numberWithoutCountryCode: '',
    };
  }

  const codeLength = callingCodeLength(digits);
  const callingCodeDigits = codeLength > 0 ? digits.slice(0, codeLength) : '';
  const numberWithoutCountryCode = codeLength > 0 ? digits.slice(codeLength) : '';
  const countryCallingCode = callingCodeDigits ? `+${callingCodeDigits}` : '';
  const fullNumber = `+${digits}`;

  return {
    displayFullNumber: numberWithoutCountryCode
      ? `${countryCallingCode} ${numberWithoutCountryCode}`
      : fullNumber,
    fullNumber,
    countryCallingCode,
    numberWithoutCountryCode,
  };
}
